/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import url from "utils/url";
import browser from "utils/browser";
import globals from "modules/globals";
import analytics from "analytics/analytics";
import environment from "modules/environment";
import userProfiler from "modules/userprofiler";
import facebookEvents from "analytics/facebook-events";
import doubleclickEvents from "analytics/doubleclick-events";
import EmailCaptureOverlay from "components/overlays/email-capture-overlay";
import { languageIsEnglish } from "modules/language";

/**
 * OOS Product Layout Info
 *
 * @description this component intends to live in the OOS product layout. Due to the poor state of
 * the Email Capture Prompt component we're making this wrapper component to read Lead clicks
 * within him and fire an stock-alert overlay (with associated analytics) as they happen.
 *
 * @see src/ssaw/portal/templates/layouts/oos_affiliate_product_layout.jinja / oos_icon_product_layout.jinja
 * @see media/web/script/components/email-capture-prompt.js
 */
export default baustein.register("oos-product-hero", {
    setupEvents(add) {
        if (this.options.productId && this.options.returnUrl) {
            add("show-bis-overlay", this.showEmailCapture);
            add("emailCaptureSuccess", "email-capture-overlay", this.onEmailCaptureSuccess);
            add("click", ".oos-product-hero__button", this.onClickHeroButton);
        }
    },

    onClickHeroButton(event) {
        let el = event.target;
        if (el.nodeName !== "A") {
            el = el.parentElement;
        }
        const reason = el.getAttribute("reason");
        analytics.event("oos-product-hero-button", "click", reason);
    },

    showEmailCapture() {
        if (!languageIsEnglish()) {
            return;
        }
        const { productId, returnUrl } = this.options;
        let overlay;

        // todo i18n urls
        const path = `/email-capture/stock-alert/${productId}/`;
        const queryParams = {
            return_url: returnUrl,
            triggered_by_lead_link: "1"
        };
        const queryParamsString = url.toURLSearchParams(queryParams);
        if (browser.getViewport() === browser.VIEWPORTS.MOBILE) {
            globals.window.location.href = `${path}?${queryParamsString}`;
        }

        overlay = new EmailCaptureOverlay({
            path: path,
            overlaySize: "small",
            queryParams: queryParams,
            renderSuccessView: false
        });

        overlay.appendTo(this.el).open();
        this.emit("openOverlay");
    },

    /**
     * @summary Email Capture Prompt component needs to be refactored...
     *
     * Duplicates email_capture_prompt#onEmailCaptureSuccess
     * @see `onEmailCaptureSuccess` in media/web/script/components/email-capture-prompt.js
     */
    onEmailCaptureSuccess(event) {
        userProfiler.saveStockAlert(this.options.productId);
        analytics.event("email_capture", "created", "stock_alert");
        analytics.tagEvent(analytics.TAG_NETWORKS.FACEBOOK, facebookEvents.EMAIL_SIGNUP);
        analytics.tagEvent(analytics.TAG_NETWORKS.DOUBLECLICK, doubleclickEvents.ANON_SIGN_UP, {
            atc_country: environment.get("country")
        });
        event.stopPropagation();
    }
});

